export const ITEM_SHOP_LOG_LIST_REQUEST = 'ITEM_SHOP_LOG_LIST_REQUEST';

export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';

